module.exports = __webpack_public_path__ + "static/media/burak.e37fd3e2.png";